export default __webpack_public_path__ + "static/media/meeting_step_1.a87bbb08.svg";